/**
 * API Service - Centralized API calls
 */

import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  signupFree: (data) => api.post('/auth/signup-free', data),
  login: (data) => api.post('/auth/login', data),
  getCurrentUser: () => api.get('/auth/me'),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

// User API
export const userAPI = {
  getTierInfo: () => api.get('/users/me/tier-info'),
  checkUpgradeEligibility: () => api.post('/users/me/check-upgrade-eligibility'),
};

// AskSara API
export const askSaraAPI = {
  getQuota: () => api.get('/asksara/quota'),
  askQuestion: (question) => api.post('/asksara/ask', { question }),
};

// Profile API (Phase 4.8)
export const profileAPI = {
  /**
   * Get current user's full profile with lock status
   * 
   * Endpoint: GET /api/profile/me/profile
   * Returns: {
   *   id, email, first_name, last_name, phone, date_of_birth,
   *   address_line_1, address_line_2, city, state, zip_code, country,
   *   is_name_locked, is_dob_locked, profile_completed, profile_completed_at,
   *   tier, role, created_at
   * }
   */
  getProfile: () => api.get('/profile/me/profile'),
  
  /**
   * Update current user's profile (user-editable fields only)
   * 
   * Endpoint: PUT /api/profile/me/profile
   * Body: {
   *   phone?, date_of_birth?, address_line_1?, address_line_2?,
   *   city?, state?, zip_code?, country?
   * }
   * 
   * Restrictions:
   * - Cannot update first_name or last_name (always locked)
   * - Cannot update date_of_birth if already locked
   * 
   * Returns: Updated profile object (same as getProfile)
   */
  updateProfile: (profileData) => api.put('/profile/me/profile', profileData),
};

export default api;
